import Vue from "vue";

Vue.directive("modalDismiss", {
  bind: function (el, binding, vNode, oldNode) {
    el.addEventListener("click", () => {
      Vue.prototype.$modal.$hide(binding.value);
    });
  },
  update: function (el) {},
  unbind: function (el) {},
});
